import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultStationRedirect } from '@app/core/routing/DefaultStationRedirect';
import { Switch } from 'react-router-dom';
import { SearchScreenAdapterPage } from './SearchScreenAdapterPage';
import { Station } from '@app/core/types/stations';

export const routeGenerator = {
  list: (station: Station) => `/search/s/${station.slug}`,
};

export function SearchRoutes() {
  return (
    <Switch>
      <AppRoute exact path={`/search/s/:slug`} component={SearchScreenAdapterPage} />

      {/* catch all: redirect to most recent station or first station */}
      <DefaultStationRedirect to={(s) => `/search/s/${s.slug}`} />
    </Switch>
  );
}
